import {
  RequestAuthCode_request,
  ConfirmAuthCode_request,
  ConfirmAuthCode_response,
  ChangePassword_Request,
  GetLoginSettings_Response,
  RequestPasswordResetToken_Request,
  ResetPassword_Request,
  Logout_Request,
  RequestAuthCode_response,
} from "./type";
import { IResponse } from "types/common";
import Api from "services/axios_instance";
import { cMock } from "@pga/utils/customMock";

const RequestAuthCodeUrl: string = process.env.REACT_APP_REQUEST_AUTH_CODE!;
const ConfirmAuthCodeUrl: string = process.env.REACT_APP_CONFIRM_AUTH_CODE!;
const ChangePasswordUrl: string = process.env.REACT_APP_CHANGE_PASSWORD!;
const GetLoginSettingsUrl: string = process.env.REACT_APP_GET_LOGIN_SETTINGS!;
const RequestPasswordResetTokenUrl: string =
  process.env.REACT_APP_REQUEST_PASSWORD_RESET_TOKEN!;
const getAccessTokenUrl: string = process.env.REACT_APP_GET_ACCESS_TOKEN!;
const logoutUrl: string = process.env.REACT_APP_LOGOUT!;
const resetPasswordUrl: string = process.env.REACT_APP_RESET_PASSWORD!;
const resetPaswordLink: string = process.env.REACT_APP_RESET_PASSWORD_LINK!;

const Authontication = {
  //post ...
  async RequestAuthCode(request: RequestAuthCode_request) {
    const response = await Api(true).post<IResponse<RequestAuthCode_response>>(
      RequestAuthCodeUrl,
      request
    );

    return response.data;
  },
  //post ...
  async ConfirmAuthCode(request: ConfirmAuthCode_request) {
    const response = await Api(true).post<IResponse<ConfirmAuthCode_response>>(
      ConfirmAuthCodeUrl,
      request
    );
    return response.data;
  },
  //post ...
  async ChangePassword(request: ChangePassword_Request) {
    const response = await Api().post<IResponse<null>>(
      ChangePasswordUrl,
      request
    );
    return response.data;
  },
  //get ...
  async GetLoginSettings(isMock = false) {
    if (isMock) cMock<GetLoginSettings_Response>({ showCaptcha: true });
    const response = await Api(true).get<IResponse<GetLoginSettings_Response>>(
      GetLoginSettingsUrl
    );
    return response.data;
  },
  //post ...
  async RequestPasswordResetToken(request: RequestPasswordResetToken_Request) {
    const response = await Api().post<IResponse<null>>(
      RequestPasswordResetTokenUrl,
      request
    );
    return response.data;
  },

  // post ...
  async ResetPassword(request: ResetPassword_Request) {
    const response = await Api(true).post<IResponse<null>>(
      resetPasswordUrl,
      request
    );

    return response.data;
  },

  // Referesh token
  async GetAccessToken() {
    const response = await Api().get(getAccessTokenUrl);
    return response.data;
  },

  async ResetPasswordLink(request: string) {
    const response = await Api().post(resetPaswordLink, request);
    return response.data;
  },

  // logout
  async Logout(request: Logout_Request) {
    const response = await Api().post(logoutUrl, request);
    return response.data;
  },
};
export default Authontication;
